"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.namespaces = exports.resources = void 0;
const common_1 = require("./common");
exports.resources = {
    ru: Object.assign({}, common_1.commonNS),
};
exports.namespaces = [...common_1.commonNamespaces];
